import React, { Component, Fragment } from 'react';
import common from 'ui-react-common';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

const UserService = common.services.UserService;
const env = common.util.env;
const api = common.services.coreAPIInstance;
const { ScriptLoader, scripts } = common.ui.components.scriptLoader;
const validPages = ['/bank-login'];

export class ChatScript extends Component {
    constructor(props) {
        super(props);
        this.initChat = this.initChat.bind(this);
        this.state = {
            page: props.location.pathname,
            scriptLoaded: false,
        };
    }

    componentDidMount() {
        this.handleStateChange();
    }

    getFields() {
        const { firstName, email } = this.props;
        return {
            name: {
                label: 'Your Name:',
                value: firstName,
            },
            email: {
                label: 'Your Email:',
                value: email,
            },
            question: {
                label: 'How can we help?',
            },
        };
    }

    getTitle() {
        const { loanStatus } = this.props;
        return this.isServicing(loanStatus)
            ? 'Rocket Loans Servicing'
            : 'Rocket Loans Support';
    }
    getProfile() {
    // TODO: DEFAULT PROFILE IN CONFIG, OTHERWISE LOAN.GET
        return this.isServicing() ? 'servicingChat' : 'originationChat';
    }

    handleStateChange() {
        this.props.history.listen((location) =>
            this.setState({ page: location.pathname })
        );
    }
    isServicing() {
        const { loanStatus } = this.props;
        return (loanStatus || 0) >= 620;
    }
    isValidPage(currentPage) {
        return validPages.some((path) => path === currentPage);
    }
    showWidget() {
        const { scriptLoaded, page } = this.state;
        return scriptLoaded && (this.isServicing() || this.isValidPage(page));
    }

    removeChat() {
        const Five9SocialWidget = window.Five9SocialWidget || false;
        if (Five9SocialWidget) {
            Five9SocialWidget.removeWidget();
        }
    }

    initChat() {
        if (env.isProd()) {
            const Five9SocialWidget = window.Five9SocialWidget;
            const { config } = this.props;
            // These lines are meant to only initialize the chat if the client is in servicing.
            if (Five9SocialWidget) {
                if (!Five9SocialWidget.widgetAdded) {
                    Five9SocialWidget.addWidget(
                        Object.assign(config, {
                            title: this.getTitle(),
                            profiles: this.getProfile(),
                            fields: this.getFields(),
                            // TODO: CHOOSE A THEME theme: "${STRING_URL.css}"
                        })
                    );
                }
            }
        }
    }

    render() {
        return (
            <Fragment>
                <ScriptLoader
                    scriptName={scripts.five9SocialWidget}
                    api={api}
                    scriptLoaded={() => this.setState({ scriptLoaded: true })}
                />
                {this.showWidget() ? this.initChat() : this.removeChat()}
            </Fragment>
        );
    }
}

ChatScript.propTypes = {
    loanStatus: PropTypes.number,
    firstName: PropTypes.string,
    email: PropTypes.string,
    config: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
    // todo: need to get this from user. currently loan status is not being returned to front end
    loanStatus: UserService.get('loanStatus'),
    firstName: UserService.get('firstName'),
    email: UserService.get('email'),
});

const mapDispatchToProps = (dispatch) => ({});

export const ConnectedChatScript = connect(
    mapStateToProps,
    mapDispatchToProps
)(ChatScript);

export default withRouter(ConnectedChatScript);
